import {
	focusAirTimeFairness,
	openAirTimeFairnessSection,
} from './adapter';
import {
	openAirTimeFairnessEditModal,
} from './modal';
import {resolveAirTimeFairness} from './resolver';

/**
 * ATF profiles.
 *
 * ATF profiles are a fixed set - three of them, edit only. There is
 * no Add and no Delete on this table, and no search: it passes
 * search={true} without a handler, so its box would filter only the
 * page on screen. None of those three is offered here.
 *
 * Declares no fields: the agent finds a profile and opens the form rather
 * than filling it in.
 */
const airTimeFairnessPlugin = {
	id: 'air_time_fairness',
	version: 1,
	commandVersion: 1,
	resource: 'air_time_fairness',
	operations: ['options', 'list', 'edit'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.atf_profiles': openAirTimeFairnessSection,
	},
	resolvers: {
		air_time_fairness: resolveAirTimeFairness,
	},
	focusHandlers: {
		air_time_fairness: (command) =>
			focusAirTimeFairness(command.params?.entity_id),
	},
	modals: {
		'air_time_fairness.edit': openAirTimeFairnessEditModal,
	},
};

export default airTimeFairnessPlugin;
